// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdvertencyContainer_VrZ_G {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 5px;
  padding-left: 20px;
  border-left: 2px solid #11a380;
  background-color: #16c09816;
  color: #4f5660;
  font-size: 12px;
  margin-top: 10px;
}
.AdvertencyContainerError_hUKyf {
  color: #dc3545;
  border-left: 2px solid #dc3545;
}
.AdvertencyIconContainer__vRU2 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #11a380;
  min-width: 15px;
  max-width: 15px;
  height: 15px;
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;

  .icon_JiNDo {
    margin: 0 auto;
  }
}
.AdvertencyContainerError_hUKyf.AdvertencyContainer_VrZ_G{
  background-color: #c0161616;
}
.AdvertencyContainerError_hUKyf {

  .AdvertencyIconContainer__vRU2 {
    background-color: #dc3545;
  }
}

.addConnection_NOtuZ {
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/Advertency/Advertency.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;;EAEvB;IACE,cAAc;EAChB;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".AdvertencyContainer {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 5px;\n  padding-left: 20px;\n  border-left: 2px solid #11a380;\n  background-color: #16c09816;\n  color: #4f5660;\n  font-size: 12px;\n  margin-top: 10px;\n}\n.AdvertencyContainerError {\n  color: #dc3545;\n  border-left: 2px solid #dc3545;\n}\n.AdvertencyIconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #11a380;\n  min-width: 15px;\n  max-width: 15px;\n  height: 15px;\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n\n  .icon {\n    margin: 0 auto;\n  }\n}\n.AdvertencyContainerError.AdvertencyContainer{\n  background-color: #c0161616;\n}\n.AdvertencyContainerError {\n\n  .AdvertencyIconContainer {\n    background-color: #dc3545;\n  }\n}\n\n.addConnection {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AdvertencyContainer": `AdvertencyContainer_VrZ_G`,
	"AdvertencyContainerError": `AdvertencyContainerError_hUKyf`,
	"AdvertencyIconContainer": `AdvertencyIconContainer__vRU2`,
	"icon": `icon_JiNDo`,
	"addConnection": `addConnection_NOtuZ`
};
export default ___CSS_LOADER_EXPORT___;
